import { render } from "./ComponenteOnBoarding.vue?vue&type=template&id=741a982a&scoped=true"
import script from "./ComponenteOnBoarding.vue?vue&type=script&lang=js"
export * from "./ComponenteOnBoarding.vue?vue&type=script&lang=js"

import "./ComponenteOnBoarding.vue?vue&type=style&index=0&id=741a982a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741a982a"]])

export default __exports__